import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { FaCheckCircle, FaBug, FaProjectDiagram, FaShieldAlt } from "react-icons/fa";
import "./ASICVerificationHighlights.css";

const features = [
  {
    id: 1,
    icon: <FaBug />,
    title: "Comprehensive Testbench Development",
    text: "Build UVM‑compliant, reusable testbench architectures to cover all design scenarios and edge cases."
  },
  {
    id: 2,
    icon: <FaCheckCircle />,
    title: "Coverage‑Driven Verification",
    text: "Leverage functional, code and assertion coverage metrics to guide test creation and close verification gaps."
  },
  {
    id: 3,
    icon: <FaProjectDiagram />,
    title: "Assertion‑Based Verification",
    text: "Embed SVA properties to formally check protocol compliance, race conditions, and deadlock freedom."
  },
  {
    id: 4,
    icon: <FaShieldAlt />,
    title: "Continuous Regression & CI",
    text: "Integrate with CI pipelines for daily regression runs, automated report generation, and early bug detection."
  },
];

const ASICVerificationHighlights = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { margin: "-100px 0px -100px 0px", once: false });

  return (
    <section ref={ref} className="verification-section">
      <motion.div
        className="verification-content"
        initial={{ opacity: 0 }}
        animate={{ opacity: isInView ? 1 : 0 }}
        transition={{ duration: 0.7 }}
      >
        <h2 className="verification-heading">Our ASIC Verification Expertise</h2>
        <p className="verification-subheading">
          From rigorous testbench architectures to formal property checking, our verification services ensure
          your ASIC design meets the highest standards of correctness and performance.
        </p>

        <div className="feature-grid">
          {features.map((f) => (
            <div key={f.id} className="feature-item">
              <div className="feature-icon">{f.icon}</div>
              <h3 className="feature-title">{f.title}</h3>
              <p className="feature-text">{f.text}</p>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default ASICVerificationHighlights;